import { render, staticRenderFns } from "./cameraSettingSidebar.vue?vue&type=template&id=20713682&scoped=true&"
import script from "./cameraSettingSidebar.vue?vue&type=script&lang=js&"
export * from "./cameraSettingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./cameraSettingSidebar.vue?vue&type=style&index=0&id=20713682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20713682",
  null
  
)

export default component.exports